<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('table_label_search')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_evgPurchaseStatus') || '单据状态'"
            >
              <dict-select
                v-model="form.listEvgPurchaseStatus"
                url="/sys/common/dict/system"
                :body="{ dictType: 'evgPurchaseStatus' }"
                :placeholder="
                  $l('form_placeholder_evgPurchaseStatus') || '请选择单据状态'
                "
                style="width: 100%"
                filterable
                size="mini"
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_evgPurchaseNo') || '采购单号'">
              <el-input
                v-model.trim="form.evgPurchaseNo"
                :placeholder="
                  $l('form_placeholder_evgPurchaseNo') || '请输入采购单号'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_salesPerson') || '业务开发'">
              <dict-select
                v-model="form.listSalesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_placeholder_salesPerson') || '请选择业务开发'
                "
                size="mini"
                style="width: 100%"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_buyer') || '采购跟单'">
              <dict-select
                v-model="form.listBuyerCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_buyer') || '请选择采购跟单'"
                style="width: 100%"
                size="mini"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_orderSource') || '订单合同名称（甲方）'"
            >
              <dict-select
                v-model="form.listOrderSource"
                url="/master/common/dict/biz"
                :body="{ dictType: 'orderSource' }"
                :placeholder="
                  $l('form_placeholder_orderSource') ||
                    '请选择订单合同名称（甲方）'
                "
                style="width: 100%"
                size="mini"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_takeOrderOrg') || '接单公司（乙方）'"
            >
              <dict-select
                v-model="form.listTakeOrderOrgCode"
                url="/sys/common/dict/system"
                :body="{ dictType: 'takeOrderOrgCode' }"
                :placeholder="
                  $l('form_placeholder_takeOrderOrgCode') ||
                    '请选择接单公司（乙方）'
                "
                style="width: 100%"
                size="mini"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_takeOrderType') || '订单类型'">
              <dict-select
                v-model="form.listTakeOrderType"
                url="/sys/common/dict/system"
                :body="{ dictType: 'takeOrderType' }"
                :placeholder="
                  $l('form_placeholder_takeOrderType') || '请选择订单类型'
                "
                clearable
                size="mini"
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('form_label_purchaseDate') || '下单日期'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.purchaseDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_purchaseDateStart') ||
                        '请选择下单日期'
                    "
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.purchaseDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_purchaseDateEnd') || '请选择下单日期'
                    "
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_importanceLevel') || '重要级别'"
            >
              <dict-select
                v-model="form.listImportanceLevel"
                url="/master/common/dict/biz"
                :body="{ dictType: 'importanceLevel' }"
                :placeholder="
                  $l('form_placeholder_importanceLevel') || '请选择重要级别'
                "
                clearable
                size="mini"
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_quotedMethod') || '报价方式'">
              <dict-select
                v-model="form.listQuotedMethod"
                url="/sys/common/dict/system"
                :body="{ dictType: 'quotedMethod' }"
                :placeholder="
                  $l('form_placeholder_quotedMethod') || '请选择报价方式'
                "
                size="mini"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item
                :label="$l('form_label_totalAmount') || '总采购金额'"
              >
                <br />
                <el-col :span="8">
                  <el-input-number
                    v-model="form.totalAmountStart"
                    :placeholder="
                      $l('form_placeholder_totalAmountStart') ||
                        '请输入总采购金额'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  />
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    v-model="form.totalAmountEnd"
                    :placeholder="
                      $l('form_placeholder_totalAmountEnd') ||
                        '请输入总采购金额'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  />
                </el-col>
                <el-col :span="7">
                  <dict-select
                    v-model="form.currencyUnit"
                    url="/master/common/dict/biz"
                    :body="{ dictType: 'currencyUnit' }"
                    :placeholder="
                      $l('form_placeholder_currencyUnit') || '请选择货币单位'
                    "
                    filterable
                    clearable
                    style="width:100%"
                    size="mini"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item :label="$l('form_label_totalQty') || '总采购数量'">
                <br />
                <el-col :span="11">
                  <el-input-number
                    v-model="form.totalQtyStart"
                    :placeholder="
                      $l('form_placeholder_totalQtyStart') || '请输入总采购数量'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="1"
                    :precision="0"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.totalQtyEnd"
                    :placeholder="
                      $l('form_placeholder_totalQtyEnd') || '请输入总采购数量'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="1"
                    :precision="0"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('form_label_deliveryDate') || '交货日期'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_deliveryDateStart') ||
                        '请选择交货日期'
                    "
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_deliveryDateEnd') || '请选择交货日期'
                    "
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_scm') || '执行工厂'">
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/scmCooperated"
                :placeholder="$l('form_placeholder_scm') || '请选择执行工厂'"
                size="mini"
                style="width: 100%"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_orderScm') || '名义工厂'">
              <dict-select
                v-model="form.listOrderScmCode"
                url="/master/common/dict/scmCooperated"
                :placeholder="
                  $l('form_placeholder_orderScm') || '请选择名义工厂'
                "
                size="mini"
                style="width: 100%"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_settlementFactory') || '结算工厂'"
            >
              <dict-select
                v-model="form.listSettlementFactory"
                url="/master/common/dict/scmCooperated"
                :placeholder="
                  $l('form_placeholder_settlementFactory') || '请选择结算工厂'
                "
                size="mini"
                style="width: 100%"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custName') || '客户'">
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('form_placeholder_custName') || '请选择客户'"
                size="mini"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_createDate') || '创建时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_createDateStart') || '请选择创建时间'
                    "
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_createDateEnd') || '请选择创建时间'
                    "
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_modifyDateStart') || '请选择修改时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_modifyDateEnd') || '请选择修改时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_submitTime') || '提交时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.submitTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_submitTimeStart') || '请选择提交时间'
                    "
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.submitTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_submitTimeEnd') || '请选择提交时间'
                    "
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_reviewTime') || '审核时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.reviewTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_reviewTimeStart') || '请选择审核时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.reviewTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_reviewTimeEnd') || '请选择审核时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = { keyword: '', listEvgPurchaseStatus: ['N', 'Y', 'S', 'R'] }
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()

    const _this = this
    this.$eventBus.$on('evgBiz-evgPurchaseOrder-list-reload', () =>
      _this.query()
    )
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
